import {Controller} from "stimulus"
import EventEmitter from "./../utils/EventEmitter"
import {getModalObjectByName} from "./../utils/utils"

export default class extends Controller {

    static targets = [
    ]

    static activeClassName = "is-active"

    initialize(){
        window.addEventListener("click", e => this.closeCurrentFromClick(e))
        document.addEventListener("keyup", e => {
            const key = event.which || event.keyCode
            if ( key === "Escape" || key === 27) {
                const $modals = this.getOpenedModals()
                $modals.forEach($modal => this.closeModal($modal))
            }
        })
        EventEmitter.on("modal-open-now", e => {
            const name = e.detail.name
            this.openByName(name)
        })
    }

    getOpenedModals() {
        const $modals = this.element.querySelectorAll(`.modal.${this.constructor.activeClassName}`)
        return $modals ? [...$modals] : []
    }

    static getModalByName(name){
        return document.querySelector(`.modal[data-modal-name=${name}]`)
    }

    /**
     * Open event
     * @param e
     */
    open(e){

        const name = e.currentTarget.dataset.modalName
        const $modal = this.constructor.getModalByName(name)
        const index = parseInt(e.currentTarget.dataset.index)

        // Dispatch before opened event
        EventEmitter.emit(`modal-before-opened-${name}`, {index})

        if ( $modal ) {

            $modal.classList.add(this.constructor.activeClassName)
            document.querySelector("html").classList.add("has-no-scroll")
            this.data.set("current", name)

        }
    }

    closePannel(){
        let activePannel = document.getElementsByClassName('side-pannel is-active')[0]
        activePannel.classList.toggle("is-active")
    }

    /**
     * Close event
     * @param e
     */
    close(e){

        const name = e.currentTarget.dataset.modalName
        const $modal = this.constructor.getModalByName(name)

        this.closeModal($modal)

    }

    closeObject(e){
        const name = e.currentTarget.dataset.modalName
        const $modal = getModalObjectByName(name)

        this.closeModal($modal)

    }

    closeModal($modal){
        $modal.classList.remove(this.constructor.activeClassName)
        document.querySelector("html").classList.remove("has-no-scroll")
        this.data.set("current", "")
        // Dispatch after closed event
        const eventBeforeOpenedName = `modal-after-closed-${$modal.dataset.modalName}`
        const eventBeforeOpened = new CustomEvent(eventBeforeOpenedName, {})
        document.dispatchEvent(eventBeforeOpened)
    }

    closeCurrentFromClick(e){


        let $modal = e.target.classList.contains("modal") ? e.target : e.target.parents(".modal")

        if ( $modal.length !== undefined ) {
            $modal = $modal.length > 0 ? $modal[0] : false;
        } else {
            $modal = $modal ? $modal : false
        }

        if ( $modal ) {
            if ( !(e.target.classList.contains("modal__content") || e.target.parents(".modal__content").length > 0) ) {
                if ( $modal.dataset.modalName === this.data.get("current") ) {
                    this.closeModal($modal)
                }
            }
        }

    }

    openByName(name, index = undefined){

        const $modal = getModalObjectByName(name)
        console.log("test")

        // Dispatch before opened event
        EventEmitter.emit(`modal-before-opened-${name}`, {index})

        if ( $modal ) {

            $modal.classList.add(this.constructor.activeClassName)
            this.data.set("current", name)

        }

    }

}